import { GROUP_METRICS_VERTICAL_PADDING } from "../../../constants/constants";
import { alertColor } from "../../../constants/colors";
import styled from "styled-components/macro";
import { GROUP_METRIC_HEIGHT } from "./groupMetricsUtils";
import { CUSTOM_SCROLLBAR_CSS_HORIZONTAL } from "App/CUSTOM_SCROLLBAR_CSS";

/* prevent scrollbar appearing when GroupMetricsFloater is on either end */
export const GROUP_METRICS_PADDING_HZ = 16;
export const GROUP_METRICS_FLOATER_HEIGHT = GROUP_METRIC_HEIGHT + 12;

export const GroupMetricsStyles = styled.div<{ $isPnlPopup?: boolean }>`
  width: 100%;
  padding: ${props =>
      props.$isPnlPopup ? GROUP_METRICS_VERTICAL_PADDING : 0}px
    0 ${props => GROUP_METRICS_VERTICAL_PADDING * (props.$isPnlPopup ? 0 : 2)}px
    0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  align-items: center;
  .metricsScrollContainer {
    width: fit-content;
    max-width: 100%;
    ${CUSTOM_SCROLLBAR_CSS_HORIZONTAL}
    overflow: auto;
    padding: 16px 8px;
    height: ${GROUP_METRICS_FLOATER_HEIGHT + 12}px;
    display: flex;
    align-items: center;
    margin: auto;
    .metrics {
      width: fit-content;
      position: relative;
      @media print {
        position: relative !important;
      }
      height: ${GROUP_METRIC_HEIGHT}px;
      display: flex;
      justify-content: center;
      padding: 0 ${GROUP_METRICS_PADDING_HZ}px;
    }
  }
`;

export const TooLongForDataDumpStyles = styled.div`
  font-size: 12px !important;
  height: 50px;
  color: ${alertColor} !important;
  box-sizing: border-box;
`;
